import { useContext } from 'react'

import { ellipsisTruncate } from 'utils/string'

import { NavTabs } from 'app/Nav'
import { SITEMAP } from 'libreon/routes'
import GlobalContext from 'reducer/global'

import { PublicPreview, UpdateBar, VerifiedBar } from '../Widgets'
import { LibreonMenu, NavButtons, SiteMenu } from './Menus'

export function menuOrgName(org) {
  return ellipsisTruncate(org?.name || '', 16)
}

export default function NavBar() {
  const [{ user, page }] = useContext(GlobalContext)
  const { hideChrome, navId } = page
  const nav = SITEMAP[navId]

  if (hideChrome) return null

  const noIdent = !user.isIdentified
  const inSignin = window.location.pathname.startsWith('/auth')

  return (
    <>
      <div className="base-navbar flex-between ph3 gh3 fixed top-0 left-0 right-0 navbar-height f2">
        <div className="flex flex-column h-100 justify-center ga2 mr2n">
          <LibreonMenu />
        </div>
        <div className="flex flex-end flex-column h-100 ml2">
          <div className="i flex-items f2 flex-grow-1 b" />
          <NavTabs />
        </div>
        <div className="ml-auto" />
        <NavButtons sectionId={page.sectionId} />
        <SiteMenu noIdent={noIdent} routeId={nav?.id} avatar={user.avatar} />
      </div>
      <div className="fixed w-100" style={{ top: 'var(--navbar-height)' }}>
        {user.isIdentified
          ? !user.verified && <VerifiedBar />
          : !inSignin && <PublicPreview />}
        <UpdateBar />
      </div>
    </>
  )
}
